import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UITabsComponent } from './ui-tabs.component';

@NgModule({
  declarations: [
    UITabsComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    UITabsComponent
  ]
})
export class UITabsModule { }
